export default {
  autor: {
    relationships: {
      latest_files: [],
    },
  },
};
